import React, { useState } from "react";
import { useCart } from "../lib/cart";
import { MapPin, MagnifyingGlass } from "@phosphor-icons/react";

/** Lightweight UK postcode filter for homepage/navigation */
export default function PostcodeFilter({ onChange, compact = false }) {
  const { postcode, setPostcode } = useCart();
  const [value, setValue] = useState(postcode || "");

  const apply = (e) => {
    e?.preventDefault();
    const pc = value.trim().toUpperCase();
    setPostcode(pc);
    onChange?.(pc);
  };

  return (
    <form
      onSubmit={apply}
      data-testid="postcode-filter"
      className={`flex items-center gap-2 bg-white border-2 border-[#E5E2D9] rounded-full ${compact ? "px-2 py-1.5" : "px-4 py-2.5"} focus-within:border-[#A94438] focus-within:ring-4 focus-within:ring-[#A94438]/10 transition-all`}
    >
      <MapPin size={18} weight="duotone" className="text-[#A94438] flex-shrink-0 ml-1" />
      <input
        data-testid="postcode-filter-input"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Enter UK postcode"
        aria-label="UK postcode"
        className="bg-transparent border-0 outline-none flex-1 min-w-0 text-sm font-semibold placeholder:text-[#5C5C54]/60 uppercase"
      />
      <button
        type="submit"
        data-testid="postcode-submit"
        className="rounded-full bg-[#1A1A18] text-white text-xs font-bold px-4 py-2 hover:bg-[#A94438] transition-all flex items-center gap-1"
      >
        <MagnifyingGlass size={14} weight="bold" />
        {compact ? "" : "Find"}
      </button>
    </form>
  );
}
